<template>
  <div class="footer">
    <div class="top content-auto">
      <div class="logo">
        <div class="logo-wrapper" @click="onHome">
          <a class="link">
            <img :src="require('@/assets/svgs/logo-dark.svg')" />
          </a>
        </div>
      </div>
      <div class="content">
        <div class="item">
          <div class="title">{{ $t('公司合作') }}</div>
          <div class="sub-item">
            <a target="_blank" :href="deliveryUrl" class="link">
              {{ $t('成为滴滴骑手') }}
            </a>
          </div>
          <div class="sub-item">
            <a
              target="_blank"
              :href="`//www.didi-food.com/${currentLanguage}/store`"
              class="link"
            >
              {{ $t('成为合作餐厅') }}
            </a>
          </div>
        </div>
        <div class="item">
          <div class="title">{{ $t('公司信息') }}</div>
          <!-- <div class="sub-item">
            <a
              target="_blank"
              :href="`//www.didi-food.com/${currentLanguage}/news-list`"
              class="link"
            >
              {{ $t('最新消息') }}
            </a>
          </div> -->
          <div class="sub-item">
            <a
              target="_blank"
              :href="`//www.didi-food.com/${currentLanguage}/about-us`"
              class="link"
            >
              {{ $t('关于滴滴外卖') }}
            </a>
          </div>
          <div class="sub-item">
            <a
              target="_blank"
              :href="`//www.didi-food.com/${currentLanguage}/contact-us`"
              class="link"
            >
              {{ $t('联系我们') }}
            </a>
          </div>
          <div class="sub-item">
            <!-- 目前只有日本 如果新增了国家需要产品确定是否需要该入口 -->
            <a
              target="_blank"
              :href="`https://jobs.lever.co/didi-global?location=${currentCountry}`"
              class="link"
            >
              {{ $t('FoodC_zhaopin_Recruitment_OZrZ') }}
            </a>
          </div>
        </div>
        <div class="item last-item" v-if="followUsShowCountry">
          <div class="title">{{ $t('关注我们') }}</div>
          <div class="sub-item">
            <a
              v-for="(link, index) in followUSConfig[country]"
              :key="index"
              target="_blank"
              :href="link.url"
              :class="link.iconClass"
              class="icon follow-img"
            >
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom content-auto">
      <div class="select">
        <!-- 展示国家 -->
        <div class="country-wrapper">
          <i class="iconfont-earth icon"></i>
          <el-select
            v-model="currentCountry"
            placeholder=""
            popper-class="country-wrapper-sel-class"
            @change="handleSwitchCountry"
          >
            <el-option
              v-for="item in countryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 展示语言 -->
        <div class="country-wrapper">
          <img
            class="icon icon-img"
            :src="require('@/assets/svgs/select-country-icon-dark.svg')"
          />
          <el-select
            v-model="currentLanguage"
            placeholder=""
            popper-class="country-wrapper-sel-class"
            @change="handleSwitchLang"
          >
            <el-option
              v-for="item in languageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="copy-right">
        <div class="copy-right-left">
          <!-- <p>
            <a
              target="_blank"
              :href="`https://img0.didiglobal.com/static/dpubimg/b0e610695c1d0be13c6c27a6fba619c2/index.html?lang=${currentLanguage}&location_country=JP`"
              class="link"
            >
              {{ $t('特定商取引法') }}
            </a>
          </p> -->
          <p class="product-name">
            ©{{ year }} {{ $t('productname_didi_food') }}
          </p>
        </div>
        <div class="copy-right-center">
          <p>
            <a
              target="_blank"
              :href="`https://img0.didiglobal.com/static/dpubimg/16aebd1620a29cccdf3914691d87c1bb/index.html?lang=${currentLanguage}&location_country=${country}`"
              class="link"
            >
              {{ $t('使用条款及隐私政策') }}
            </a>
          </p>
        </div>
        <!-- <div class="copy-right-right">
          <a href="javascript:;" @click="handleAppStoreClick">
            <img class="download-exe" :src="require(`@/assets/svgs/download/download_appstore_${currentLanguage}.svg`)">
          </a>
          <a href="javascript:;" @click="handleGooglePlay">
            <img class="download-google-play" :src="require(`@/assets/svgs/download/download_google_${currentLanguage}.svg`)">
          </a>
        </div>  -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getLocale } from '@/utils/locale';
import { getUrlOrigin } from '@/utils/baseUtil';
import { countryLocaleMap, countryAbbreviationFlipMap } from '@/config/countryConfig/list/country-locale-map';
import { getDeliveryUrl } from '@/utils/baseUtil';
import config from '@/config/default';
import {
  getLanguageOptionsForCountry,
  countryOptions,
  followUSConfig,
} from '@/config/countryConfig/list/footer';
export default {
  name: 'my-footer',
  data() {
    return {
      year: new Date().getFullYear(),
      currentCountry: '',
      currentLanguage: getLocale(),
      locale: getLocale(),
      deliveryUrl: '',
      followUSConfig: followUSConfig,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.deliveryUrl = getDeliveryUrl({
        locale: this.locale,
        country: this.country,
      });
    });
    // developer.didi-food.com 默认英语，可以切换西语、英语、日语
    // developer.food.99app.com 默认葡语，可以切换葡语、英语
    this.currentCountry = countryAbbreviationFlipMap[this.country]
  },
  computed: {
    ...mapState({
      country: ({ common }) => common.country,
    }),
    countryOptions() {
      return countryOptions;
    },
    languageOptions() {
      return getLanguageOptionsForCountry(this.country);
    },
    followUsShowCountry() {
      return !!this.followUSConfig[this.country]?.length
    }
  },
  methods: {
    onHome() {
      if (this.$route.path === '/feed') {
        window.location.reload();
      } else {
        this.$router.push('/feed');
      }
    },
    handleSwitchCountry(value) {
      this.currentCountry = value
      let defatultLocale = countryLocaleMap[value].defaultLocale;
      window.location.href = `${getUrlOrigin()}/${defatultLocale}/food`;
    },
    handleSwitchLang(value) {
      window.location.href = `${getUrlOrigin()}/${value}/food${
        this.$route.fullPath
      }`;
    },
    handleAppStoreClick() {
      this.openUrl(config.appMap.ios.url);
    },
    handleGooglePlay() {
      this.openUrl(config.appMap.android.url);
    },
    openUrl(url) {
      url && window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.footer {
  .el-input {
    margin-left: 25px;
    width: 155px;
    height: 28px;
    line-height: 28px;
  }
  .el-input__suffix {
    height: 28px;
    right: 10px;
    .el-input__suffix-inner {
      height: 28px;
      i {
        display: inline-block;
        color: #000;
      }
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .el-input__inner {
    width: 150px;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    border: 0;
    background: none;
    border-radius: 0;
    color: #000;
  }
}
.country-wrapper-sel-class {
  margin-bottom: 8px !important;
  border: none !important;
  .popper__arrow {
    display: none !important;
  }
  .el-select-dropdown__item {
    color: #999;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #f5f5f7;
  }
}
@media screen and (max-width: 768px) {
  .footer {
    .el-input {
      margin-left: rem(50);
      width: rem(250);
      height: rem(48);
      line-height: rem(48);
    }
    .el-input__suffix {
      height: rem(48);
      right: rem(20);
      .el-input__suffix-inner {
        height: rem(48);
        i {
          color: #000;
        }
      }
      .el-input__icon {
        line-height: rem(48);
      }
    }
    .el-input__inner {
      width: 150px;
      height: rem(48);
      font-size: rem(24);
      line-height: rem(48);
      border: 0;
      background: none;
      border-radius: 0;
      color: #000;
    }
  }
}
</style>
